// extracted by mini-css-extract-plugin
module.exports = {"component":"Formatted_component__37LRy","big":"Formatted_big__2Sav5","load":"Formatted_load__bHkrm"};